// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ExpandableIcon {\n  bottom: 4px;\n  background-color: white;\n  border: 0 none;\n  color: #3a8fdd;\n  cursor: pointer;\n  font: inherit;\n  pointer-events: none;\n  position: absolute;\n  right: 6px;\n}\n\ntextarea:focus + .ExpandableIcon {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
